import { Outlet } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

export default function AppLayout() {
  return (
    <>
      <Toaster position="bottom-center" containerClassName="!top-20" />
      <Outlet />
    </>
  );
}
